import { GridColDef } from "@mui/x-data-grid";

export const reportTypeColumns: GridColDef[] = [
  { field: "name", headerName: "Name", flex: 1 },
  { field: "url", headerName: "URL", flex: 1 },
  { field: "description", headerName: "Description", flex: 1 },
];
